import React,{ Component }  from 'react';
import {connect}            from 'react-redux';
import RenderHeader         from '../../../container/renderHeader';
import {iframe }            from '../../../actions/jogosAction';
import {GetTipoAtividade}   from '../../../actions/atividadesAction'; 
import { GetActionBg }      from '../../../actions/scopoAction';
import {Config}             from '../../../actions/configActions';
import bg_desafios          from "../../../img/bg/bg_desafios.png";
import bg_chave             from "../../../img/bg/bg_chave.png";
import bg_bomba             from "../../../img/bg/bg_bomba.png";
import bg_quiz              from "../../../img/bg/bg_quiz.png";

class Missoes_Aluno_Jogos extends Component{

    constructor(props){
        super(props);
        this.state = {
                        ati_id   : this.props.match.params.ati_id,
                        ati_tipo : this.props.match.params.ati_tipo,
                        titulo   : ""
                    }
    }

    componentWillMount(){
    
        localStorage.setItem('ati_id',this.state.ati_id);
        switch (this.state.ati_tipo) {
           
            case this.props.menu.desafios.jogo.tipo1: 
                 this.props.GetActionBg(bg_chave);
            break;

            case this.props.menu.desafios.jogo.tipo2: 
                 this.props.GetActionBg(bg_bomba);
            break;    

            case this.props.menu.desafios.jogo.tipo3: 
                 this.props.GetActionBg(bg_quiz);
            break;
            default:
            break;
        }
    }

    renderJogos(){
        const obj = {}	
        switch (this.state.ati_tipo) {

            case this.props.menu.desafios.jogo.tipo1: 
                 obj.retorno = this.props.iframe(`${Config().ip}/animacoes/chave/chave.html`);
            break;
           
            case this.props.menu.desafios.jogo.tipo2: 
                 obj.retorno = this.props.iframe(`${Config().ip}/animacoes/bomba/bomba.html`);
            break;
            
            case this.props.menu.desafios.jogo.tipo3: 
                 obj.retorno = this.props.iframe(`${Config().ip}/animacoes/quiz/quiz.html`);
            break;

            default:
            break;
        }

        return obj.retorno; 
    }

    render(){
       const redm = {"paddingBottom": "56.25%"}
        return(      <div className="hud-middle-center active">
        <div className="container-bg">
           
                        <div style={redm} dangerouslySetInnerHTML={{__html: this.renderJogos()}}/>
                            <div className="alert alert-info">
                                <b>Atenção: </b>Sua pontuação só será atualizada se você ganhar mais XP ou pontos do que na sua última tentativa. Ou seja, só será considerada a maior pontuação obtida.	
                        </div> 
                 
        </div>
        </div>    
             );
}

}

function mapStateToProps(state){
    
        return {
          menu : state.configReducer.menu
        }
    }

export default connect(mapStateToProps,{iframe,GetTipoAtividade,GetActionBg})(Missoes_Aluno_Jogos);

   {/* <div className="hud-middle-center active">
                <div className="container-bg">
                   
                                <div dangerouslySetInnerHTML={{__html: this.renderJogos()}}/>
                                    <div className="alert alert-info">
                                        <b>Atenção: </b>Sua pontuação só será atualizada se você ganhar mais XP ou pontos do que na sua última tentativa. Ou seja, só será considerada a maior pontuação obtida.	
                                </div> 
                         
                </div>
                </div> */}


// WEBPACK FOOTER //
// ./src/components/aluno/desafios/desafios_aluno_jogos.js